
import { useNavigate } from 'react-router-dom'
import{ useEffect, useRef, useState } from 'react'
import { useSpring,animated } from 'react-spring'
import Lottie from 'lottie-react'
import arrow from './Arrow.json'
import down from './down.json'
import right from './right.json'
import more from './more.json'
import ReactLoading from 'react-loading'
import './Counter.css'
const Explore = () => {
  function Number({n}){
    const {number} =useSpring({
      from:{number:0},
      number:n,
      delay:200,
      config:{mass:1,tension:20,friction:10},
    });
    return <animated.div className=' md:mx-3 lg:text-3xl mx-3 text-2xl' style={{color:'red',fontFamily:'initial'}}>{number.to((n)=>n.toFixed(0))}</animated.div>
  }
    const action=useNavigate()
    const navlink=()=>{
        action('home')
    }
    const nav=useNavigate();
  return (
    <div >
      <div className='background'></div>
      <div className='overlay'></div>
      <div className=' text-white md:text-4xl font-bold flex justify-center font-sans my-4 text-xl relative md:mt-56 mt-32'>Explore The Best Reliable Listings</div>
      <h3 className=' flex justify-center lg:text-lg relative text-white mx-5'>  With over 200+ Hostels, Apartments, GuestHoues And Homestels listed on our webpage.You can't leave here Homeless.</h3>
      <div className=' flex justify-center my-6 relative text-white'>
      <div className='inline-block md:mx-5 md:text-lg text-sm font-semibold mx-2'>
      <div className=' inline-block -mx-2 '><Number n={400}/></div>  
      <div className=' inline-block top-44 text-3xl -mx-1' style={{color:'red'}}>+</div>
        <div>Hostels</div>
      </div>
      <div className='inline-block md:mx-5 md:text-lg text-sm font-semibold mx-2'>
      <div className=' inline-block'><Number n={150}/></div>  
      <div className=' inline-block top-44 text-3xl -mx-3' style={{color:'red'}}>+</div>
        <div>Apartments</div>
      </div>
      <div className='inline-block md:mx-5 md:text-lg text-sm font-semibold mx-2'>
      <div className=' inline-block'><Number n={300}/></div>  
      <div className=' inline-block top-44 text-3xl -mx-3' style={{color:'red'}}>+</div>
        <div>Homestels</div>
      </div>
      <div className='inline-block md:mx-5 md:text-lg text-sm font-semibold mx-2'>
      <div className=' inline-block'><Number n={70}/></div>  
      <div className=' inline-block top-44 text-3xl -mx-3' style={{color:'red'}}>+</div>
        <div>GuestHouses</div>
      </div>
      </div>
      <div className='flex justify-center' >
      <Lottie animationData={more} style={{width:'50px',}} />
      </div>
      <div className='flex justify-center  my-6 relative'>
      <button onClick={navlink} className=' bg-green-600  w-56 h-12 rounded-md border-slate-900 shadow-lg text-white font-mono font-extrabold text-xl '>Explore Listing</button> 
      </div>
      <div className='flex justify-center relative'>
      <button  className=' bg-gray-700 w-56 h-12 rounded-md border-slate-900 shadow-lg text-white font-mono font-extrabold text-xl'> <a href='https://docs.google.com/forms/d/e/1FAIpQLSfHhFw1IdCrfBvh894GMYX6oN_11U1VcmxICjztzVyruI_pTA/viewform?usp=sf_link'>Add my Property</a></button> 
      </div>
    </div>
  )
}

export default Explore
